import { create } from "zustand";

export interface AlertDialogStateProps {
  title: string;
  description: string;
  onConfirm: () => void;
  confirmText?: string;
  onCancel?: () => void;
  cancelText?: string;
}

export interface UseAlertDialogStoreStates extends AlertDialogStateProps {
  isOpen?: boolean;
  setAlertDialogState: (alertDialogState: AlertDialogStateProps) => void;
  resetAlertDialogState: () => void;
}

const DEFAULT_ALERT_DIALOG_STATE: AlertDialogStateProps = {
  title: "",
  description: "",
  onConfirm: () => {},
  confirmText: "확인",
  cancelText: "취소",
};

export const useAlertDialogStore = create<UseAlertDialogStoreStates>((set) => ({
  isOpen: false,
  ...DEFAULT_ALERT_DIALOG_STATE,
  setAlertDialogState: (alertDialogState: AlertDialogStateProps) => {
    set(() => ({
      isOpen: true,
      ...alertDialogState,
    }));
  },
  resetAlertDialogState: () => {
    set({
      isOpen: false,
      ...DEFAULT_ALERT_DIALOG_STATE,
    });
  },
}));
